import { Box, Container, Grid2 as Grid, Typography } from '@mui/material';
import { MdCameraAlt, MdDirectionsBus, MdEventSeat, MdPool } from 'react-icons/md';

const iconSx = {
    background: {
        width: '100%',
    },
    heading: {
        textAlign: 'center',
        paddingTop: { xs: '40px', sm: '64px' },
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: { xs: '20px', sm: '36px' },
        paddingBottom: '40px',
    },
    iconOuter: {
        width: '4.5rem',
        height: '4.5rem',
        backgroundColor: 'primary.light',
        borderRadius: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 8px 24px rgba(247, 97, 0, 0.14)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 14px 30px rgba(247, 97, 0, 0.22)',
        },
        marginTop: { xs: '32px', sm: 0 },
    },
} as const;

const eyebrowSx = {
    color: 'primary.main',
    letterSpacing: '0.2em',
    fontWeight: 800,
    fontSize: '0.8rem',
    textTransform: 'uppercase',
    mb: 1.5,
} as const;

const headingSx = {
    fontSize: { xs: 30, md: 40 },
    fontWeight: 700,
    color: 'text.primary',
    lineHeight: 1.12,
    letterSpacing: '-1px',
    m: 0,
} as const;

const featureTitleSx = {
    fontWeight: 700,
    color: 'text.primary',
    mt: 3,
    mb: 0.75,
    textAlign: 'center',
    fontSize: '1.1rem',
    lineHeight: 1.3,
    letterSpacing: '-0.2px',
} as const;

const featureBodySx = {
    fontWeight: 400,
    color: 'text.soft',
    mx: 'auto',
    textAlign: 'center',
    fontSize: '0.95rem',
    lineHeight: 1.5,
    maxWidth: 230,
} as const;

export default function IconSection() {
    const iconColor = 'rgba(247, 97, 0, 1)';
    const iconSize = '2rem';

    const sections = [
        {
            title: 'Window seats guaranteed',
            body: 'An unobstructed view out the window on every scenic flight.',
            icon: (
                <MdEventSeat
                    style={{
                        fontSize: iconSize,
                        color: iconColor,
                    }}
                />
            ),
        },
        {
            title: 'Fly & snorkel the reef',
            body: 'Pair your flight with a cruise and snorkel the Great Barrier Reef.',
            icon: (
                <MdPool
                    style={{
                        fontSize: iconSize,
                        color: iconColor,
                    }}
                />
            ),
        },
        {
            title: 'Unreal photo ops',
            body: 'Capture the Great Barrier Reef from the air like never before.',
            icon: (
                <MdCameraAlt
                    style={{
                        fontSize: iconSize,
                        color: iconColor,
                    }}
                />
            ),
        },
        {
            title: 'Free city transfers',
            body: 'Complimentary courtesy bus to and from Cairns City.',
            icon: (
                <MdDirectionsBus
                    style={{
                        fontSize: iconSize,
                        color: iconColor,
                    }}
                />
            ),
        },
    ];

    return (
        <Box sx={iconSx.background}>
            <Container maxWidth="lg">
                <Box sx={iconSx.heading}>
                    <Typography component="p" sx={eyebrowSx}>
                        The GSL difference
                    </Typography>
                    <Typography component="h2" sx={headingSx}>
                        Why fly with us
                    </Typography>
                </Box>
                <Grid container sx={iconSx.container}>
                    {sections.map((s, i) => (
                        <Grid
                            container
                            direction="column"
                            alignItems="center"
                            size={{ xs: 12, sm: 6, md: 3 }}
                            key={`icon${i + 1}`}
                        >
                            <Box sx={iconSx.iconOuter}>{s.icon}</Box>
                            <Typography component="h3" sx={featureTitleSx}>
                                {s.title}
                            </Typography>
                            <Typography sx={featureBodySx}>{s.body}</Typography>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}
